module.exports = __webpack_public_path__ + "static/media/pathfinder-2018.ac8108e7.jpg";